import { Component } from '@angular/core';
import { FeedbackValue } from '@yupma/ui-kit';

@Component({
  selector: 'app-sidebar-feedback',
  templateUrl: './sidebar-feedback.component.html',
  styleUrl: './sidebar-feedback.component.scss'
})
export class SidebarFeedbackComponent {
  isWidgetOpen: boolean = false;

  constructor() { }

  openWidget() {
    this.isWidgetOpen = true;
  }

  closeWidget() {
    this.isWidgetOpen = false;
  }

  feedbackSubmit(feedback: FeedbackValue) {
    // const feed: FeedbackDocument = new FeedbackDocument(feedback.rating, feedback.text, String(window.location), DateUtils.getCurrentTimeStamp())
    // this.userDataService.addSeoLensExtensionFeedback(feed);
    console.log(feedback);

    setTimeout(() => {
      this.closeWidget();
    }, 5000);
  }
}
